import "./About.css";

const About = () => {
    return (
        <div className="about-page">
            <div className="about-container">

                <h1 className="about-title">О компании</h1>

                <p className="about-intro">
                    Добро пожаловать в наше интернет-пространство уникальной мебели «Фактура» —
                    место, где рождаются уютные и стильные интерьеры.
                </p>

                <p>
                    Мы помогаем людям обновлять пространство вокруг себя: создаём и подбираем мебель,
                    которая не просто заполняет комнаты, а делает жизнь комфортнее и ярче.
                    Если вы мечтаете преобразить дом — вы попали по адресу.
                </p>

                <h2>Почему стоит выбрать нас?</h2>

                <ul className="about-list">
                    <li>
                        <strong>Экспертный подход.</strong> Наши дизайнеры и консультанты знают всё о
                        сочетаемости стилей, эргономике и трендах. Поможем подобрать предметы так,
                        чтобы они гармонично вписались в ваш дом.
                    </li>

                    <li>
                        <strong>Качество без компромиссов.</strong> Мы работаем только с надёжными
                        производителями и тщательно проверяем каждый товар.
                    </li>

                    <li>
                        <strong>Широкий выбор.</strong> В каталоге — мебель на любой вкус: от классики
                        до модерна, от минимализма до эклектики. Есть решения для квартир,
                        загородных домов и небольших студий.
                    </li>

                    <li>
                        <strong>Удобство покупки.</strong> Простой сайт, подробные описания и фото,
                        быстрая доставка и сборка — всё для лёгкой и приятной покупки.
                    </li>
                </ul>

                <h2>Необычные находки для вашего интерьера</h2>

                <ul className="about-list">
                    <li>
                        <strong>Авторские лампы.</strong> Мы создаём их в коллаборации с российскими
                        мастерами-керамистами и находим уникальные основания в галереях и на
                        блошиных рынках Европы. Абажуры — из дизайнерских тканей.
                    </li>

                    <li>
                        <strong>Дизайнерские подушки и арт-объекты.</strong> Необычные формы,
                        авторские ткани, гобелены в единственном экземпляре.
                    </li>

                    <li>
                        <strong>Кровати, диваны, кресла.</strong> Подбираем так, чтобы каждый предмет
                        стал акцентом интерьера.
                    </li>

                    <li>
                        <strong>Текстиль для дома.</strong> Полотенца, пледы, постельное бельё —
                        разные фактуры, цвета и ценовые категории.
                    </li>
                </ul>

                <p className="about-highlight">
                    Создавайте новый образ вашего пространства за пару минут.
                </p>

                <p className="about-footer">
                    Мы верим, что мебель — это не просто предметы обстановки, а часть вашей истории.
                    Начните преображение сегодня — выберите мебель, которая будет радовать вас годами.
                </p>

            </div>
        </div>
    );
};

export default About;
